import { $, w } from './constants';

const getVisibleCount = (version) => {
  if (version === 'version-1') return 3.25;
  if (version === 'version-2') return 3.5;
  return 2.5; // version-3
};

const isMobile = () => $(window).width() < 768;

const createCarousel = (element) => {
  const $element = $(element);
  const $track = $element.find('[data-carousel-track]');
  const $slides = $track.find('.carousel-slide');
  const $prevButton = $element.find('.carousel-button-prev');
  const $nextButton = $element.find('.carousel-button-next');
  const $container = $element.find('.carousel-container');

  if ($slides.length === 0) return;

  const version = $element.hasClass('carousel-version-1')
    ? 'version-1'
    : ($element.hasClass('carousel-version-2') ? 'version-2' : 'version-3');

  let cardWidth = 0;
  let gap = 20;

  const updateSlideWidth = () => {
    const containerWidth = $container.width();

    if (!containerWidth || containerWidth === 0) {
      const parentWidth = $element.parent().width() || $(window).width();
      $container.css('width', '100%');
      setTimeout(updateSlideWidth, 100);
      return;
    }

    gap = isMobile() ? 20 : (version === 'version-2' ? 10 : 20);

    const cardsVisible = isMobile() ? 1 : getVisibleCount(version);

    const gapsCount = Math.ceil(cardsVisible);
    const totalGapWidth = gap * gapsCount;

    let calculatedCardWidth = (containerWidth - totalGapWidth) / cardsVisible;

    if (version === 'version-2' && !isMobile() && calculatedCardWidth > 415) {
      calculatedCardWidth = 415;
    }

    cardWidth = calculatedCardWidth;

    $slides.css('width', `${calculatedCardWidth}px`);
    $slides.css('margin-right', `${gap}px`);

    if (version === 'version-2' && !isMobile()) {
      $track.css('gap', '0');
    }
  };

  const getStep = () => {
    return $slides.first().outerWidth(true) || (cardWidth + gap);
  };

  const updateButtons = () => {
    const el = $container.get(0);
    if (!el) return;

    const maxScrollLeft = el.scrollWidth - el.clientWidth;

    const atStart = el.scrollLeft <= 1;
    const atEnd = el.scrollLeft >= (maxScrollLeft - 1);

    $prevButton.prop('disabled', atStart).toggleClass('is-disabled', atStart);
    $nextButton.prop('disabled', atEnd).toggleClass('is-disabled', atEnd);
  };

  const prev = () => {
    const el = $container.get(0);
    if (!el) return;
    el.scrollBy({ left: -getStep(), behavior: 'smooth' });
  };

  const next = () => {
    const el = $container.get(0);
    if (!el) return;
    el.scrollBy({ left: getStep(), behavior: 'smooth' });
  };

  let ticking = false;
  const onScroll = () => {
    if (ticking) return;
    ticking = true;

    requestAnimationFrame(() => {
      updateButtons();
      ticking = false;
    });
  };

  const init = () => {
    updateSlideWidth();
    updateButtons();

    $prevButton.on('click', prev);
    $nextButton.on('click', next);

    $container.on('scroll', onScroll);

    $(window).on('resize', () => {
      updateSlideWidth();
      updateButtons();
    });
  };

  init();
};

$(document).ready(function () {
  $('.carousel').each(function () {
    createCarousel(this);
  });
});